<slick-dialog #dialogRef header="Readings &amp; Dosages" [width]="700">
	<div class="p-2" style="text-align: left;">
		<!-- Opened from an appointment the tech is at a site rather than on one asset, so the pool/spa
		     is chosen here. Opened from the Assets tab the caller already fixed it. -->
		<div class="row" *ngIf="showStructurePicker && structures.length > 0">
			<div class="col-12 col-lg-6 mb-3">
				<label class="form-label">Pool / Spa</label>
				<select class="form-select form-select-sm" [(ngModel)]="structureId">
					<option [ngValue]="null">Not specified</option>
					<option *ngFor="let s of structures" [ngValue]="s.id">
						{{ getStructureTypeName(s.structureTypeId) }}: {{ s.description }}
					</option>
				</select>
			</div>
		</div>

		<div class="row">
			<!-- Readings -->
			<div class="col-12 col-lg-6 mb-3">
				<h5 class="text-primary border-bottom pb-2">Readings</h5>
				<table class="table table-sm">
					<thead>
						<tr>
							<th>Reading</th>
							<th style="width: 45%;">Value</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let row of readingRows; let i = index">
							<td class="align-middle">{{row.itemName}}<span class="text-muted" *ngIf="row.uom"> ({{row.uom}})</span></td>
							<td>
								<div class="rd-suggest-wrap">
									<input class="form-control form-control-sm" autocomplete="off" [(ngModel)]="row.itemValue"
										   (focus)="openPanel('reading', i)" (blur)="closePanelSoon()" />
									<div class="rd-suggest-panel rd-panel-right" *ngIf="isPanelOpen('reading', i) && matchValues(row.values, row.itemValue).length">
										<div class="rd-suggest-item" *ngFor="let v of matchValues(row.values, row.itemValue)"
											 (mousedown)="selectValue('reading', row, v)">{{v}}</div>
									</div>
								</div>
							</td>
						</tr>
						<tr *ngIf="readingRows.length === 0">
							<td colspan="2" class="text-center text-muted py-2">No readings configured.</td>
						</tr>
					</tbody>
				</table>
			</div>

			<!-- Dosages -->
			<div class="col-12 col-lg-6 mb-3">
				<h5 class="text-primary border-bottom pb-2">Dosages</h5>
				<table class="table table-sm">
					<thead>
						<tr>
							<th>Dosage</th>
							<th style="width: 30%;">Value</th>
							<th class="text-center" style="width: 25%;">Invoice</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let row of dosageRows; let i = index">
							<td class="align-middle">{{row.description}}<span class="text-muted" *ngIf="row.uom"> ({{row.uom}})</span></td>
							<td>
								<div class="rd-suggest-wrap">
									<input type="number" class="form-control form-control-sm" autocomplete="off" [(ngModel)]="row.value"
										   (focus)="openPanel('dosage', i)" (blur)="closePanelSoon()" />
									<div class="rd-suggest-panel rd-panel-left" *ngIf="isPanelOpen('dosage', i) && matchValues(row.values, row.value).length">
										<div class="rd-suggest-item" *ngFor="let v of matchValues(row.values, row.value)"
											 (mousedown)="selectValue('dosage', row, v)">{{v}}</div>
									</div>
								</div>
							</td>
							<td class="text-center align-middle">
								<input *ngIf="row.hasItem" type="checkbox" [(ngModel)]="row.addToInvoice" [disabled]="row.value === null || row.value === undefined" />
							</td>
						</tr>
						<tr *ngIf="dosageRows.length === 0">
							<td colspan="3" class="text-center text-muted py-2">No dosages configured.</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>

	<slick-dialog-footer>
		<button type="button" class="btn btn-outline-success me-2" style="width: 120px;" [slick-button-spinner]="spinnerStatus" (click)="save()">
			<i class="bi bi-check-circle"></i> Save
		</button>
		<button type="button" class="btn btn-outline-danger" style="width: 120px;" (click)="cancel()">
			<i class="bi bi-x-circle"></i> Cancel
		</button>
	</slick-dialog-footer>
</slick-dialog>
